import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomSelect from "../../../../Components/CustomSelect";
import PercentIcon from "@mui/icons-material/Percent";
import FormNumberInput from "../../../../Components/FormNumberInput";

const Step4_GuarantorsAndSavings = ({ guarantorshipOptions, yesNoOptions }) => {
  const {
    control,
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  const guarantorship = watch("guarantorship");
  const allowMultiplierTimes = watch("allow_multiplier_times");

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="guarantorship"
          id="guarantorship"
          value={guarantorship || ""}
          label="Guarantorship"
          onChange={(e) => setValue("guarantorship", e.target.value)}
          options={guarantorshipOptions}
        />
      </Grid>

      {guarantorship === "YES" && (
        <>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormNumberInput
              name="maximum_guarantor_percentage"
              control={control}
              label={`Maximum guarantor percentage`}
              // defaultValue={100}
              min={0}
              rules={{
                required: "Enter Maximum guarantor percentage",
              }}
              disableGrouping={true}
              endAdornment={
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              }
            />

            {/* <FormControl
              fullWidth
              error={!!errors.maximum_guarantor_percentage}
            >
              <InputLabel htmlFor="maximum_guarantor_percentage">
                Maximum guarantor percentage
              </InputLabel>
              <OutlinedInput
                id="maximum_guarantor_percentage"
                type="number"
                {...register("maximum_guarantor_percentage")}
                label="Maximum guarantor percentage"
                onWheel={(event) => event.target.blur()}
                fullWidth
                defaultValue="100"
                inputProps={{ step: "any", min: 0 }}
                endAdornment={
                  <InputAdornment position="end">
                    <PercentIcon />
                  </InputAdornment>
                }
              />
              {errors.maximum_guarantor_percentage && (
                <FormHelperText>
                  Enter maximum guarantor percentage!
                </FormHelperText>
              )}
            </FormControl> */}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormNumberInput
              name="maximum_saving_percentage"
              control={control}
              label={`Maximum saving percentage`}
              min={0}
              disableGrouping={true}
              rules={{
                required: "Enter Maximum saving percentage",
              }}
              endAdornment={
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              }
            />
            {/* <FormControl fullWidth error={!!errors.maximum_saving_percentage}>
              <InputLabel htmlFor="maximum_saving_percentage">
                Maximum saving percentage
              </InputLabel>
              <OutlinedInput
                id="maximum_saving_percentage"
                type="number"
                {...register("maximum_saving_percentage")}
                label="Maximum saving percentage"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                fullWidth
                defaultValue="0"
                endAdornment={
                  <InputAdornment position="end">
                    <PercentIcon />
                  </InputAdornment>
                }
              />
              {errors.maximum_saving_percentage && (
                <FormHelperText>
                  Enter maximum saving percentage!
                </FormHelperText>
              )}
            </FormControl> */}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <CustomSelect
              labelId="allow_multiplier_times"
              id="allow_multiplier_times"
              value={allowMultiplierTimes || ""}
              label="Allow multiplier times"
              onChange={(e) =>
                setValue("allow_multiplier_times", e.target.value)
              }
              options={yesNoOptions}
            />
          </Grid>

          {allowMultiplierTimes === "YES" && (
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth error={!!errors.multiplier_times}>
                <InputLabel htmlFor="multiplier_times">
                  Multiplier times
                </InputLabel>
                <OutlinedInput
                  id="multiplier_times"
                  type="number"
                  {...register("multiplier_times")}
                  label="Multiplier times"
                  onWheel={(event) => event.target.blur()}
                  inputProps={{ step: "any", min: 0 }}
                  fullWidth
                  defaultValue="0"
                />
                {errors.multiplier_times && (
                  <FormHelperText>Enter multiplier times!</FormHelperText>
                )}
              </FormControl>
            </Grid>
          )}
        </>
      )}

      {guarantorship === "NO" && (
        <>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.minimum_saving_amount}>
              <InputLabel htmlFor="minimum_saving_amount">
                Minimum saving amount
              </InputLabel>
              <OutlinedInput
                id="minimum_saving_amount"
                type="number"
                {...register("minimum_saving_amount")}
                label="Minimum saving amount"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                fullWidth
                defaultValue="0"
              />
              {errors.minimum_saving_amount && (
                <FormHelperText>Enter minimum saving amount!</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.upto_saving_percentage}>
              <InputLabel htmlFor="upto_saving_percentage">
                Upto saving amount
              </InputLabel>
              <OutlinedInput
                id="upto_saving_percentage"
                type="number"
                {...register("upto_saving_percentage")}
                label="Upto saving amount"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                fullWidth
                defaultValue="0"
                endAdornment={
                  <InputAdornment position="end">
                    <PercentIcon />
                  </InputAdornment>
                }
              />
              {errors.upto_saving_percentage && (
                <FormHelperText>Enter Upto saving amount!</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Step4_GuarantorsAndSavings;
